import React, { useEffect } from "react";
import Button from "./Button";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const CTA = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <section
      data-aos="fade-up"
      data-aos-duration="800"
      className="relative flex flex-col lg:flex-row items-center justify-between px-[25px] sm:px-16 gap-12 mt-24"
    >
      {/* CURVED TOP ACCENT */}
      <div className="absolute -top-10 left-0 w-full h-20 bg-primary_red/5 rounded-b-[50%]"></div>

      {/* IMAGE SIDE */}
      <div className="relative w-full lg:w-1/2 rounded-3xl overflow-hidden shadow-xl">
        <img
          src="./assets/bmt/donate_now_sec.jpeg"
          alt="Donate and support BMT patients"
          className="object-cover w-full h-full"
        />

        {/* Dim overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/60"></div>

        {/* Emotional Hope Badge */}
        <div className="absolute top-6 right-4 bg-white/90 px-4 py-2 rounded-full text-primary_red font-semibold shadow-lg text-sm">
          Bringing Hope. Saving Lives.
        </div>
      </div>

      {/* TEXT SIDE */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center">
        {/* Title */}
        <h2 className="text-[32px] lg:text-[44px] font-extrabold leading-tight text-primary_red">
          This is a Call to Action.
        </h2>
        <h3 className="text-[26px] lg:text-[34px] font-bold leading-tight text-black mt-2">
          Be a Hero — Your Support Saves Lives.
        </h3>

        {/* Description */}
        <p className="mt-6 text-[18px] md:text-[20px] text-gray-700 leading-relaxed">
          Your donation helps subsidise the Bone Marrow Transplant procedure for
          Nigerians living with Sickle Cell Disorder. Your kindness directly
          impacts families, giving children and adults a real chance at a cure.
        </p>

        {/* WHY IT MATTERS BOX */}
        <div className="mt-6 p-5 bg-primary_red/10 border border-primary_red/20 rounded-2xl shadow-sm backdrop-blur-sm">
          <h4 className="font-bold text-primary_red text-[20px] mb-2">
            Why Your Donation Matters:
          </h4>

          <ul className="space-y-2 text-gray-700 text-[16px]">
            <li>
              ✓ It supports families who cannot afford this life-saving
              treatment.
            </li>
            <li>
              ✓ It gives children a chance to live free from Sickle Cell
              complications.
            </li>
            <li>
              ✓ It strengthens Nigeria’s capacity for world-class medical care.
            </li>
          </ul>
        </div>

        {/* IMPACT STATS */}
        <div className="mt-6 flex items-center gap-6">
          <div>
            <h3 className="text-primary_red font-extrabold text-[32px] leading-none">
              80%
            </h3>
            <p className="text-gray-600 text-[14px]">
              of affected Nigerians cannot afford a transplant
            </p>
          </div>
          <div>
            <h3 className="text-primary_red font-extrabold text-[32px] leading-none">
              1 Life
            </h3>
            <p className="text-gray-600 text-[14px]">
              saved can transform an entire family
            </p>
          </div>
        </div>

        {/* DONATE BUTTON WITH PULSE */}
        <div className="relative mt-10">
          <div className="absolute inset-0 rounded-full bg-primary_red/40 blur-2xl animate-pulse"></div>

          <Link to="/donation" className="relative z-10 inline-block">
            <Button
              classes="px-[52px] py-[14px] bg-primary_red font-Lexend font-bold rounded-full 
                       text-[16px] shadow-lg hover:shadow-xl hover:bg-primary_red/90 
                       transition-all tracking-wide text-white"
              text="Donate Now"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;
